<template>
  <div
    ref="chartContainer"
    class="chart-container"
    style="width: 100%; height: 100%"
  ></div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";

let list = [
  // { percent: "", name: "土地租赁成本", value: 961 },
  // { percent: "", name: "亩均的成本", value: 991 },
  { percent: "", name: "农机", value: 275 },
  { percent: "", name: "种子", value: 171 },
  { percent: "", name: "打药", value: 120 },
  { percent: "", name: "灌溉", value: 60 },
  { percent: "", name: "化肥 ", value: 340 }
]
let sum = list.reduce((cur, pre) => {
  return cur + pre.value;
}, 0);
var nameArray = list.map(item => {
  return item.name + '\t\t\t' + item.value + '元' + '\t\t\t' + item.percent
})

var color = ['#28FCEF', '#073B72', '#708EFC', '#268AFF', '#ECFF6D', '#ADE1FF',"#D68339"]
var data = [];
for (var i = 0; i < list.length; i++) {
  data.push({
    value: list[i].value,
    name: list[i].name + '\t\t\t' + list[i].value + '元' + '\t\t\t' + list[i].percent ,
    itemStyle: {
      borderWidth: 6,
      borderColor: color[i],
    }
  });
}
// 创建ECharts配置对象
const option = {
  // backgroundColor: "#061740",
  color: color,
  tooltip: {
    trigger: 'item'
  },
  title: {
    text:"农资",
    subtext: '费用统计',
    left: '59%',
    top: '39%',
    textAlign :'center',
    textStyle: {
      color: '#28FFF2',
      fontSize: 16,
    },
    subtextStyle: {
      fontSize: 16,
      color: '#28FFF2'
    },
  },
  legend: [{
    orient: 'vertical',
    data: nameArray,
    icon: 'rect',
    left: '10%',
    top: 'center',
    align: 'left',
    itemGap: 10,
    textStyle: {
      color: '#fff',
      fontSize: "14",
    },
    //图例标记的图形高度
    itemHeight: 10,
    //图例标记的图形宽度
    itemWidth: 10,
  }],
  series: [{
    name: '',
    type: 'pie',
    clockwise: false,
    radius: ['65%', '90%'],
    width: "80%",
    height: "80%",
    emphasis: {
      scale: false
    },
    center: ['75%', '50%'],
    top: "center",
    label: {
      show: false,
      position: 'inside',
      color: '#fff',
      formatter: function (params) {
        console.log(params)
        return params.percent + '%'
      }
    },
    data: data
  }]


};

// 创建ECharts实例的ref
const chartContainer = ref(null);

// 初始化ECharts实例
onMounted(() => {
  if (chartContainer.value) {
    const chartInstance = echarts.init(chartContainer.value);
    chartInstance.setOption(option);


    // 监听窗口尺寸变化
    window.addEventListener("resize", () => {
      chartInstance.resize();
    });
  }
});
</script>

<style scoped>
.chart-container {
  height: 400px; /* 或者自定义高度 */
  width: 100%;
}
</style>
